<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="app-main-inner-row" style="padding-top: 10px;">
        <div v-if="$store.getters.isGroupCompany" class="filters">
          <el-form :inline="true" label-width="80px" label-position="left" @submit.native.prevent>
            <el-form-item :label="$t('CargoMsg.Cargo_SelectBranch')">
              <el-select ref="select" v-model="branchIds" multiple filterable style="width: 218px" @change="changeOfficeHandler" @visible-change="onVisibleChange">
                <el-option :value="0" :label="$t('Message.All')" />
                <el-option
                  v-for="office in currentOfficeList"
                  :key="office.uuid"
                  :value="office.officeId"
                  :label="office.code"
                />
              </el-select>
              <el-button size="mini" type="primary" style="margin-left: 5px;" @click="showBranchSelectDialog">...</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="triggers">
          <span>{{ $t('CargoMsg.Cargo_Search') }}</span>
          <el-input
            v-model="keyword"
            :placeholder="$t('common.tips.fuzzySearch')"
            style="width:200px;margin: 0 10px"
            @input="toQuery({likeName:keyword,pageNum:1, officeId: branchIds})"
          />
          <el-button type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
          <el-button type="primary" @click="onCopy">{{ $t('CargoMsg.Cargo_Copy') }}</el-button>
          <el-button type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
          <el-button size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="manualFilter.reload=true;toQuery({likeName:keyword,pageNum:1, officeId: branchIds})"
          >{{ $t('common.btn.refresh') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="200101"
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div>
        <cargo-pagination
          v-show="total>0"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="manualPage.paginationClick=true;toQuery()"
        />
      </div>
    </div>
    <!-- 用于打开新的报表页面，以post方式提交 -->
    <form ref="reportForm" :action="report.url" target="_blank" method="post" style="display:none">
      <input v-for="item in report.formEntries" :key="decodeURIComponent(item[0])" :name="decodeURIComponent(item[0])" :value="decodeURIComponent(item[1])">
    </form>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item :label="$t('SystemMaintenance.AdditionalOutputAssociatedTemplate')">
            <el-select
              v-model="editDialog.form.coverTemplateUuid"
              :disabled="editDialog.form.engine===0"
              @focus="coverTemplateFocus"
            >
              <el-option
                v-for="(item,index) in coverTemplateList"
                :key="index"
                :label="item.name"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.FileClassification')">
            <cargo-advance-select
              :cache="false"
              filterable
              :default-value="editDialog.form.documentTypeUuid"
              :static-options="documentTypeList"
              style="width: 150px"
              filter-type="global"
              tag-name="listShowName"
              tag-value="uuid"
              :filter-tag-names="['listShowName']"
              @parentCallBack="p=>editDialog.form.documentTypeUuid=p.value"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.TemplateEngine')">
            <el-select v-model="editDialog.form.engine" @change="engineChange">
              <el-option label="JasperReport" :value="0" />
              <el-option label="StiReport" :value="1" />
              <el-option label="V3" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.FilterScript')">
            <el-input v-model="editDialog.form.filter" :filter-chars="false" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_PrintChannel')">
            <el-select v-model="editDialog.form.printChannel">
              <el-option
                v-for="(item,index) in printCancelList"
                :key="index"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.TemplateName')">
            <el-input v-model="editDialog.form.name" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.BranchSerialNumber')">
            <el-select v-model="editDialog.form.officeId">
              <el-option
                v-for="(item,index) in officeList"
                :key="index"
                :label="item.chineseName"
                :value="item.officeId"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Remark')">
            <el-input v-model="editDialog.form.remarks" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.TemplateFile')">
            <el-input v-model="editDialog.form.templateFile" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.TemplateClass')">
            <el-input v-model="editDialog.form.templateType" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.TemplateUsage')">
            <el-select v-model="editDialog.form.templateUsage">
              <el-option :label="$t('SystemMaintenance.Printing')" :value="0" />
              <el-option :label="$t('SystemMaintenance.Email')" :value="1" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 分公司选择弹窗 -->
    <branch-select-dialog :visible.sync="branchSelectDialog.visible" :value="branchSelectDialog.value" :office-list="currentOfficeList" @callback="branchSelectDialog.callback" />
  </div>
</template>

<script>
import { cacheName, cache } from '@/utils/cacheManager'
import { getDocumentTypeListFunc } from '@/api/documentType'
import { getTemplateTypeList } from '@/api/sysManage/baseConfig/templateType'
import { getTemplateList, getInitTemplateList, saveTemplate, copyTemplate, batchDeleteTemplate } from '@/api/sysManage/baseConfig/template'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getUserInfo } from '@/utils/auth'
import * as CommonUtil from '@/utils/commonUtil'
import BranchSelectDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/BranchSelectDialog'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { PRINT_CANCEL_LIST } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TemplateManagement',
  components: { cargoAdvanceSelect, BranchSelectDialog },
  data() {
    return {
      user: {},
      selectTypeNames: TYPE_NAMES,
      branchIds: [],
      officeList: [],
      printCancelList: PRINT_CANCEL_LIST,
      officeMap: new Map(),
      relatedTemplateList: [],
      relatedTemplateMap: new Map(),
      coverTemplateList: [],
      documentTypeList: [],
      documentTypeMap: new Map(),
      manualFilter: {
        data: [],
        reload: true
      },
      manualPage: {
        data: [],
        paginationClick: false
      },
      keyword: '',
      filter: {
        officeId: '',
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('SystemMaintenance.AdditionalOutputAssociatedTemplate'),
          field: 'coverTemplateUuidStr',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.FileClassification'),
          field: 'documentTypeUuidStr',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.TemplateFileCloudStorageID'),
          cellRenderer: params => {
            if (params.data.engine !== 1 && params.data.engine !== 2) {
              return params.data.documentId
            }
            if (params.data.documentId) {
              return `<u onclick="document.templateManage.editReport('${params.data.uuid}')" style="cursor:pointer">${params.data.documentId}</u>`
            } else {
              return `<u onclick="document.templateManage.createReport('${params.data.uuid}')" style="cursor:pointer">创建模板</u>`
            }
          },
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.TemplateEngine'),
          field: 'engineStr',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.FilterScript'),
          field: 'filter',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.TemplateName'),
          field: 'name',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.BranchSerialNumber'),
          field: 'officeIdStr',
          width: 200
        }, {
          headerName: this.$t('SystemMaintenance.Remark'),
          field: 'remarks',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.TemplateFile'),
          field: 'templateFile',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.TemplateSerialNumber'),
          field: 'templateId',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.TemplateClass'),
          field: 'templateType',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.TemplateUsage'),
          field: 'templateUsageStr',
          width: 100
        }
      ],
      rowData: [],
      report: {
        template: null,
        templateType: null,
        designMode: 0,
        url: '',
        formEntries: []
      },
      editDialog: {
        visible: false,
        title: '',
        initialForm: null,
        form: {
          uuid: '',
          coverTemplateUuid: '',
          documentTypeUuid: '',
          documentId: '',
          engine: 0,
          filter: '',
          printChannel: null,
          name: '',
          officeId: '',
          remarks: '',
          templateFile: '',
          templateId: 0,
          templateType: '',
          templateUsage: 0
        }
      },
      branchSelectDialog: {
        visible: false,
        value: [],
        callback: () => {}
      },
      branchIdsIsEdit: false
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    }
  },
  watch: {
    branchIds() {
      this.$nextTick(() => {
        this.onVisibleChange(this.branchIdsIsEdit)
      })
    }
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.OFFICE_LIST)
    this.user = cache.user
    this.officeList = cache.officeList
    for (const item of this.officeList) {
      this.officeMap.set(item.officeId, item.chineseName)
    }
    await getDocumentTypeListFunc({}).then(res => {
      this.documentTypeList = res.data
      for (const item of this.documentTypeList) {
        this.documentTypeMap.set(item.uuid, item.name)
      }
    })
    await this.toQuery()
    this.report.designMode = this.$checkPermission(['role_template_design']) ? 1 : 0
    this.editDialog.initialForm = this.editDialog.form
  },
  beforeMount() {
    const context = this
    document.templateManage = {
      createReport(uuid) {
        context.createReport(uuid)
      },
      editReport(uuid) {
        context.editReport(uuid)
      }
    }
  },
  methods: {
    toQuery(params) {
      if (params) {
        this.filter.officeId = params.officeId || ''
        this.filter.likeName = params.likeName || ''
        this.filter.pageNum = params.pageNum || this.filter.pageNum
      }
      return this.getTemplatePage(this.filter).then(res => {
        res.data.list.forEach(p => {
          if (p.engine !== 0 && p.coverTemplateUuid) {
            p.coverTemplateUuidStr = this.relatedTemplateMap.get(p.coverTemplateUuid)
          } else {
            p.coverTemplateUuidStr = ''
          }
          if (p.documentTypeUuid) {
            p.documentTypeUuidStr = this.documentTypeMap.get(p.documentTypeUuid)
          } else {
            p.documentTypeUuidStr = ''
          }
          switch (p.engine) {
            case 0: p.engineStr = 'JasperReport'; break
            case 1: p.engineStr = 'StiReport'; break
            case 2: p.engineStr = 'V3'; break
            default: p.engineStr = ''
          }
          p.officeIdStr = this.officeMap.get(p.officeId)
          p.templateUsageStr = p.templateUsage > 0 ? this.$t('SystemMaintenance.Email') : this.$t('SystemMaintenance.Printing')
        })
        if (this.gridApi) {
          this.gridApi.setRowData(res.data.list)
        } else {
          this.rowData = res.data.list
        }
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = res.data.total
      })
    },
    async getTemplatePage(params) {
      if (this.manualPage.paginationClick) {
        this.manualPage.paginationClick = false
      } else {
        await this.getTemplateByFilter(params).then(res => {
          this.manualPage.data = res.data
        })
      }
      const list = []
      const pageNum = this.filter.pageNum
      const pageSize = this.filter.pageSize
      const total = this.manualPage.data.length
      for (let i = (pageNum - 1) * pageSize; i < total && i < pageNum * pageSize; ++i) {
        list.push(this.manualPage.data[i])
      }
      return { data: { list, pageNum, pageSize, total }}
    },
    async getTemplateByFilter(params) {
      if (this.manualFilter.reload) {
        await getTemplateList({}).then(res => {
          this.manualFilter.data = res.data
        }).then(() => {
          const map = new Map()
          this.relatedTemplateList = this.manualFilter.data.filter(p => p.engine !== 0)
          for (const item of this.relatedTemplateList) {
            map.set(item.uuid, item.name)
          }
          this.relatedTemplateMap = map
        })
        this.manualFilter.reload = false
      }
      const likeName = params.likeName.toLowerCase()
      const list = this.manualFilter.data.filter(p => {
        if (params.officeId) {
          if (params.officeId instanceof Array) {
            if (params.officeId.length > 0 && !params.officeId.includes(p.officeId)) {
              return false
            }
          } else {
            if (p.officeId !== params.officeId) {
              return false
            }
          }
        }
        if (likeName) {
          if (p.name && p.name.toLowerCase().indexOf(likeName) > -1) {
            return true
          }
          if (p.remarks && p.remarks.toLowerCase().indexOf(likeName) > -1) {
            return true
          }
          return false
        }
        return true
      })
      return { data: list }
    },
    async beforeReport(uuid) {
      const template = this.manualPage.data.filter(p => p.uuid === uuid)[0]
      const templateType = await getTemplateTypeList({ templateType: template.templateType }).then(res => {
        return res.data.list.length > 0 ? res.data.list[0] : null
      })
      if (!templateType || !templateType.schemaType) {
        this.$message.warning(this.$t('SystemMaintenance.SchemaTypeNotMaintained'))
        return false
      }
      this.report.template = template
      this.report.templateType = templateType
      await cache.load(cacheName.CONFIG)
      return true
    },
    async createReport(uuid) {
      const isPass = await this.beforeReport(uuid)
      if (!isPass) {
        return
      }
      const template = this.report.template
      const templateType = this.report.templateType
      if (template.engine === 2) {
        const initTemplate = await getInitTemplateList({ schemaType: templateType.schemaType }).then(res => {
          return res.data.length > 0 ? res.data[0] : null
        })
        if (initTemplate === null) {
          this.$message.warning(this.$t('SystemMaintenance.CannotCheckWhetherTheCorrect'))
          return
        }
        this.report.url = cache.config.get('V3ServerURL') + '/report/designer'
        const form = {}
        form.TEMPALTE_TYPE = template.templateType
        form.OFFICE_ID = this.currentOfficeId
        form.USER_ID = this.user.userId
        form.___SESSION_ID = this.user.sessionId
        form.sessionId = this.user.sessionId
        form.___TEMPLATE_UUID = template.uuid
        form.___SCHEMA_TYPE = templateType.schemaType
        form.___REPORT_PATH = this.user.tenantId
        form.___UPDATE_CLOUD_DOCID_URL = cache.config.get('CargoApiURL') + 'api/external-service/trackingInfo/updateTrackingForDocumentType'
        form.___DESIGN_MODE = this.report.designMode
        form.___UPDATE_PRINTED_STATE_URL = ''
        form.___RECEIVER_EMAIL = this.user.email
        form.___CLOUD_FILE_EXTATION = null
        form.remarks = template.remarks
        form.___STORAGE_FILE_ID = initTemplate.storageId
        form.___CLOUD_FILE_PREFIX = initTemplate.templateName
        // V3模板设计时将所有的key设置为空，传到V3服务器上
        form.___PARAMSTRS = PrintTemplateManager.toUrlArgs(form) + this.getCommonParams()
        this.toSubmit(form)
      } else {
        this.report.url = cache.config.get('StiReportServerURL') + 'StiRptCreate.aspx'
        const form = {}
        form.USER_ID = this.user.userId
        form.___SESSION_ID = this.user.sessionId
        form.___TEMPLATE_UUID = template.uuid
        form.___SCHEMA_TYPE = templateType.schemaType
        form.___REPORT_PATH = this.user.tenantId
        form.___UPDATE_CLOUD_DOCID_URL = cache.config.get('CargoApiURL') + 'api/external-service/trackingInfo/updateTrackingForDocumentType'
        form.___DESIGN_MODE = this.report.designMode
        form.___UPDATE_PRINTED_STATE_URL = ''
        form.___RECEIVER_EMAIL = this.user.email
        this.toSubmit(form)
      }
    },
    async editReport(uuid) {
      const isPass = await this.beforeReport(uuid)
      if (!isPass) {
        return
      }
      const template = this.report.template
      const templateType = this.report.templateType
      if (template.engine === 2) {
        this.report.url = cache.config.get('V3ServerURL') + '/report/designer'
        const form = {}
        form.TEMPALTE_TYPE = template.templateType
        form.OFFICE_ID = this.currentOfficeId
        form.USER_ID = this.user.userId
        form.___SESSION_ID = this.user.sessionId
        form.sessionId = this.user.sessionId
        form.___TEMPLATE_UUID = template.uuid
        form.___SCHEMA_TYPE = templateType.schemaType
        form.___REPORT_PATH = this.user.tenantId
        form.___DESIGN_MODE = this.report.designMode
        form.___UPDATE_PRINTED_STATE_URL = null
        form.___RECEIVER_EMAIL = this.user.email
        form.___CLOUD_FILE_EXTATION = null
        form.___STORAGE_FILE_ID = template.documentId || 'null'
        form.___CLOUD_FILE_PREFIX = template.name
        form.remarks = template.remarks
        // V3模板设计时将所有的key设置为空，传到V3服务器上
        form.___PARAMSTRS = PrintTemplateManager.toUrlArgs(form) + this.getCommonParams()
        this.toSubmit(form)
      } else {
        this.report.url = cache.config.get('StiReportServerURL') + 'StiRptCreate.aspx'
        const form = {}
        form.USER_ID = this.user.userId
        form.___SESSION_ID = this.user.sessionId
        form.___TEMPLATE_UUID = template.uuid
        form.___SCHEMA_TYPE = templateType.schemaType
        form.___REPORT_PATH = this.user.tenantId
        form.___REPORT_FILE_ID = template.templateFile || 'null'
        form.___RECEIVER_EMAIL = ''
        form.___DESIGN_MODE = this.report.designMode
        this.toSubmit(form)
      }
    },
    toSubmit(form) {
      form['zone'] = CommonUtil.requestTimeZone() // 获取当前时区
      this.report.formEntries = Object.entries(form)
      this.$nextTick(() => {
        let msg = '=============打印报表post参数=============\n'
        const tags = this.$refs.reportForm.getElementsByTagName('input')
        for (const item of tags) {
          msg += `${item.name}: ${item.value}\n`
        }
        console.log(msg + '=============END=============')
        this.$refs.reportForm.submit()
      })
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = { ...this.editDialog.initialForm }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridOptions.api.getFocusedCell()
        const nodes = this.gridOptions.api.rowModel.rowsToDisplay
        const selectedRow = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
        if (!selectedRow) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        const form = { ...selectedRow }
        if (form.engine === 0) {
          form.coverTemplateUuid = ''
        }
        // 分公司默认值转换
        if (form.officeId === 0) {
          form.officeId = ''
        }
        this.editDialog.form = form
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.coverTemplateList = this.relatedTemplateList
      this.editDialog.visible = true
    },
    coverTemplateFocus() {
      const form = this.editDialog.form
      this.coverTemplateList = this.relatedTemplateList.filter(p => p.templateType === form.templateType && p.uuid !== form.uuid)
    },
    engineChange() {
      const form = this.editDialog.form
      if (form.engine === 0) {
        form.coverTemplateUuid = ''
      }
    },
    save() {
      const form = this.editDialog.form
      // 外键如果为空字符串，则置为null（避免更新报错）
      if (!form.documentTypeUuid) {
        form.documentTypeUuid = null
      }
      // 分公司默认值转换
      if (!form.officeId) {
        form.officeId = 0
      }
      saveTemplate(form).then(res => {
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.manualFilter.reload = true
        this.toQuery()
        this.editDialog.visible = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
      }).catch(() => {
        this.editDialog.visible = false
      })
    },
    remove() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('Message.ConfirmDeleteN', [rows.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const keys = Array.from(rows, p => p.uuid)
        batchDeleteTemplate(keys).then(res => {
          this.filter.pageNum = 1
          this.manualFilter.reload = true
          this.toQuery()
          this.$message.success(this.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    },
    changeOfficeHandler() {
      this.manualFilter.reload = true
      this.manualPage.paginationClick = false
      this.toQuery({ likeName: this.keyword, pageNum: 1, officeId: this.branchIds })
    },
    showBranchSelectDialog() {
      this.branchSelectDialog.value = this.branchIds
      this.branchSelectDialog.callback = val => {
        this.branchIds = val
        this.changeOfficeHandler()
      }
      this.branchSelectDialog.visible = true
    },
    onCopy() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.branchSelectDialog.value = []
      this.branchSelectDialog.callback = val => {
        if (val.length === 0) {
          return
        }
        const loading = getLoading4Cxt(this)
        copyTemplate(val, selectedRow.uuid).then(res => {
          this.filter.pageNum = 1
          this.manualFilter.reload = true
          this.toQuery()
          this.$message.success(this.$t('SeaExport.CopySuccess'))
        }).finally(() => {
          loading.close()
        })
      }
      this.branchSelectDialog.visible = true
    },
    onVisibleChange(isEdit) {
      this.branchIdsIsEdit = isEdit
      this.convertMultiSelectedToText()
    },
    convertMultiSelectedToText() {
      this.$nextTick(() => {
        const select = this.$refs.select
        const tags = select.$el.querySelector('.el-select__tags')
        if (!tags || !tags.childNodes || tags.childNodes.length === 0) {
          return
        }
        let customDisplay = null
        let input = null
        for (const child of tags.childNodes) {
          if (!child.classList) {
            continue
          }
          if (child.classList.contains('custom-display')) {
            customDisplay = child
          } else if (child.classList.contains('el-select__input')) {
            input = child
          }
        }
        if (!customDisplay) {
          customDisplay = document.createElement('span')
          customDisplay.className = 'custom-display'
          tags.insertBefore(customDisplay, tags.childNodes[0])
        }
        if (this.isEdit) {
          customDisplay.style.display = 'none'
          if (input) {
            input.style.display = ''
            input.value = ''
            input.setAttribute('placeholder', this.getMultiDisplay(input.offsetWidth))
            input.focus()
          }
        } else {
          customDisplay.style.display = ''
          customDisplay.innerText = this.getMultiDisplay(customDisplay.offsetWidth)
          customDisplay.setAttribute('title', this.getMultiDisplay())
          if (input) {
            input.style.display = 'none'
          }
        }
      })
    },
    getMultiDisplay(width) {
      const texts = []
      for (const branchId of this.branchIds) {
        if (branchId === 0) {
          texts.push(this.$t('Message.All'))
          continue
        }
        const office = this.currentOfficeList.find(p => p.officeId === branchId)
        if (office) {
          texts.push(office.code)
        }
      }
      if (typeof width === 'number') {
        return this.getTextEllipsis(texts.join(','), width, 12, 9)
      }
      return texts.join(',')
    },
    getTextEllipsis(text, width, fontSize = 12, paddingWidth = 25) {
      if (width > 0) {
        const textWidth = this.getTextWidth(text, fontSize, paddingWidth)
        if (textWidth > width) {
          for (let i = 3; i <= text.length; ++i) {
            const subText = text.substring(0, i)
            const subTextWidth = this.getTextWidth(subText, fontSize, paddingWidth)
            if (subTextWidth > width) {
              return text.substring(0, i - 2) + '...'
            }
          }
        }
      }
      return text
    },
    getTextWidth(text, fontSize, paddingWidth) {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      ctx.font = `normal ${fontSize}px sans-serif`
      return ctx.measureText(text).width + paddingWidth
    },
    getCommonParams() {
      const str = '&ACT_ACTUAL_AMOUNT_UUID=null&CHARGE_UUID=null&DOC_UUID=null&JOB_UUID=null&POITEMS_UUID=null&BILLING_UUID=null&INQUIRY_PRICE_UUID=null&ASSEMBLY_PLAN_UUID=null' +
        '&BILL_PAYMENT_UUID=null&BILL_PAYMENT_UUID_LIST=null&CONTAINER_UUID=null&CUSTOMS_INFO_UUID=null&FILE_UUID=null&INVOICE_UUID=null&VOUCHERS_UUID=null' +
        '&TRUCKING_UUID=null&COMPANY_UUID=null&QUOTATION_UUID=null&SPECIAL_GOOD_UUID=null&VGM_UUID=null&WAREHOUSE_UUID=null' +
        '&US_CUSTOMS_CLEARANCE_UUID=null&CHANGE_CHARGE_LIST_UUID=null&MANIFEST_INFO_UUID=null&UUIDS=null&CAR_FORM_UUID_LIST=null' +
        '&PICKING_ORDER_UUID=null&&US_CUSTOMS_CLEARANCE_CARGO_UUID=null'
      return str
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-view .main-content::v-deep {
  .el-select {
    .el-select__tags {
      .custom-display {
        width: 100%;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        margin-left: 9px;
      }
      .el-tag--info {
        display: none;
      }
      .el-select__input {
        margin-left: 9px;
        font-size: 12px;
      }
    }
  }
}
</style>
